module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Black.0c5e0292.woff";